import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import SoundsDashboard from '../../../SleepHub/SoundsDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { fetchCompanySoundsDashboard } from './companySleepApi';

/**
 * Company Sleep → Sounds Dashboard.
 *
 * The same dashboard the super admin sees, minus the library half: a company
 * admin has no view of the content catalogue, only of what its own people
 * played. Recreating the fetcher when the B2B/Members toggle flips makes the
 * shared dashboard refetch with the new scope.
 */
const CSleepSounds = () => {
  const { isB2BFansMode } = useContext(SidebarContext);

  const fetcher = useCallback(
    () => fetchCompanySoundsDashboard(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sleep Sounds | Shoorah</title>
      </Helmet>
      <SoundsDashboard
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
        showLibrary={false}
      />
    </div>
  );
};

export default CSleepSounds;
